import React from "react";
import PropTypes from "prop-types"
import _ from "lodash";

import {
    Alert,
    UncontrolledAlert,
} from "reactstrap";

const ServerErrorWidget = ({errors,displayAsAlert})=>{
    let ctr = 1;
    return(
        <>
        {
            !displayAsAlert  &&  
            <div className="mt-2">
                <UncontrolledAlert color="danger" >
                    <ul>
                        <span className="font-weight-bold">Following error occured:</span>
                        {errors.map(e=>{
                            return <li key={ctr++}>{e}</li>
                        })}
                    </ul>
                </UncontrolledAlert>
            </div>
        }
        {
            displayAsAlert && 
            <Alert color="danger">
                <div className="d-flex align-items-center align-content-center">
                    <ul>
                        <span className="font-weight-bold">Following error occured:</span>
                        {errors.map(e=>{
                            return <li key={ctr++}>{e}</li>
                        })}
                    </ul>
                </div>
            </Alert>
        }
        </>
        
    );
}

ServerErrorWidget.propTypes = {
    errors:PropTypes.array.isRequired,
    displayAsAlert:PropTypes.bool
}

ServerErrorWidget.defaultProps = {
    displayAsAlert:false,
    
}
export default ServerErrorWidget;